type DownloadBlobArgs = {
    blob: Blob;
    fileName: string;
};

export const downloadBlob = ({ blob, fileName }: DownloadBlobArgs) => {
    const objectUrl = URL.createObjectURL(blob);

    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = objectUrl;
    a.download = fileName;

    try {
        a.click();
    } finally {
        setTimeout(() => {
            URL.revokeObjectURL(objectUrl);
            a.remove();
        }, 0);
    }
};
